import { axiosRequest } from "helpers";

export const dropdownValuesService = {
	getBanks,
};

const API_URL = process.env.REACT_APP_API_URL;

function getBanks(body) {
	const options = {
		method: "POST",
		data: body,
		url: `${API_URL}/api/pre_applications/dropdown/Banks`,
	};

	return axiosRequest(options);
}
